import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryTransfer: BlogMetaData = {
  title: '保育園の転園完全ガイド｜理由・手続き・後悔しない転園先の選び方',
  description:
    '保育園の転園はタイミングと手続き、子どもへの配慮が鍵。転園理由の整理から自治体への申請手順、年度途中でも動きやすい認可外という選択肢まで、モンテ歴20年以上の園長がわかりやすく解説します。',
  thumbnailUrl: '/img/blog-nursery-transfer.webp',
  filePath: buildBlogFilePath('nursery-transfer'),
  category: BLOG_CATEGORY.NURSERY,
};
